import './header-drawer-original.js';

const MOBILE_DRILLDOWN_STYLE_ID = 'matriarch-mobile-header-drilldown-style';
const MOBILE_DRILLDOWN_MEDIA = '(max-width: 749px)';
const TOP_LEVEL_FLAT_ITEM_SELECTOR = '.menu-drawer__navigation > .menu-drawer__menu.has-submenu > .menu-drawer__list-item--flat';
const mobileDrilldownMedia = window.matchMedia(MOBILE_DRILLDOWN_MEDIA);
let setupQueued = false;
let bodyObserver;

function installMobileHeaderDrilldownStyles() {
  if (document.getElementById(MOBILE_DRILLDOWN_STYLE_ID)) return;

  const style = document.createElement('style');
  style.id = MOBILE_DRILLDOWN_STYLE_ID;
  style.textContent = `
    .menu-drawer__mobile-submenu-header {
      display: none;
    }

    @media screen and (max-width: 749px) {
      .header-drawer ${TOP_LEVEL_FLAT_ITEM_SELECTOR},
      .header-drawer .menu-drawer__list-item--mobile-drilldown {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        min-height: calc(2 * var(--padding-lg) + var(--icon-size-xs));
        margin-block-end: 0;
      }

      .header-drawer .menu-drawer__navigation > .menu-drawer__menu.has-submenu > .menu-drawer__list-item > .menu-drawer__menu-item--mainlist {
        min-height: calc(2 * var(--padding-lg) + var(--icon-size-xs));
        font-family: inherit !important;
        font-style: normal !important;
        font-weight: 400 !important;
        font-size: 16px !important;
        line-height: 1.35 !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
        color: inherit;
      }

      .header-drawer ${TOP_LEVEL_FLAT_ITEM_SELECTOR} > .menu-drawer__menu-item--mainlist,
      .header-drawer .menu-drawer__list-item--mobile-drilldown > .menu-drawer__menu-item--mainlist {
        width: 100%;
        padding: var(--padding-2xs) 0;
      }

      .header-drawer ${TOP_LEVEL_FLAT_ITEM_SELECTOR} > .menu-drawer__menu-item--mainlist::after,
      .header-drawer .menu-drawer__list-item--mobile-drilldown > .menu-drawer__menu-item--mainlist::after {
        content: '›';
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-inline-start: auto;
        font-size: 1.65rem;
        line-height: 1;
        font-family: Arial, sans-serif;
        font-weight: 300;
      }

      .header-drawer ${TOP_LEVEL_FLAT_ITEM_SELECTOR} > .menu-drawer__menu--childlist,
      .header-drawer .menu-drawer__list-item--mobile-drilldown > .menu-drawer__menu--childlist {
        position: absolute;
        inset: 0;
        z-index: var(--layer-menu-drawer);
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100dvh;
        margin: 0;
        padding: 0 var(--drawer-padding) var(--padding-xl);
        background-color: var(--color-background);
        transform: translateX(100%);
        visibility: hidden;
        opacity: 1;
        overflow-y: auto;
        transition: transform var(--drawer-animation-speed) ease, visibility var(--drawer-animation-speed) ease;
      }

      .header-drawer ${TOP_LEVEL_FLAT_ITEM_SELECTOR}[open-mobile-submenu] > .menu-drawer__menu--childlist,
      .header-drawer .menu-drawer__list-item--mobile-drilldown[open-mobile-submenu] > .menu-drawer__menu--childlist {
        transform: translateX(0);
        visibility: visible;
      }

      .header-drawer ${TOP_LEVEL_FLAT_ITEM_SELECTOR} > .menu-drawer__menu--childlist > .menu-drawer__list-item,
      .header-drawer .menu-drawer__list-item--mobile-drilldown > .menu-drawer__menu--childlist > .menu-drawer__list-item {
        width: 100%;
        min-height: auto;
      }

      .header-drawer ${TOP_LEVEL_FLAT_ITEM_SELECTOR} > .menu-drawer__menu--childlist .menu-drawer__menu-item,
      .header-drawer .menu-drawer__list-item--mobile-drilldown > .menu-drawer__menu--childlist .menu-drawer__menu-item {
        font-family: inherit !important;
        font-style: normal !important;
        font-weight: 400 !important;
        font-size: 16px !important;
        line-height: 1.4 !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
      }

      .header-drawer .menu-drawer__mobile-submenu-header {
        position: sticky;
        top: 0;
        z-index: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-inline: calc(-1 * var(--drawer-padding));
        background-color: var(--color-background);
      }

      .header-drawer .menu-drawer__mobile-back-button {
        flex: 1 1 auto;
        justify-content: flex-start;
        min-width: 0;
        font-family: inherit !important;
        font-style: normal !important;
        font-weight: 400 !important;
        font-size: 16px !important;
        line-height: 1.35 !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
      }

      .header-drawer .menu-drawer__mobile-back-icon {
        margin-inline-end: var(--padding-md);
        font-family: Arial, sans-serif;
        font-size: 1.65rem;
        line-height: 1;
        font-weight: 300;
      }

      .header-drawer .menu-drawer__mobile-close-button {
        flex: 0 0 auto;
      }

      .header-drawer .menu-drawer__mobile-close-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: var(--icon-size-xs);
        height: var(--icon-size-xs);
        font-family: Arial, sans-serif;
        font-size: 1.35rem;
        line-height: 1;
        font-weight: 300;
      }
    }
  `;
  document.head.appendChild(style);
}

function getDrawerPanel(drawer) {
  return drawer.querySelector('[ref="menuDrawer"], .menu-drawer');
}

function prepareMobileHeaderDrilldownItem(item) {
  if (!(item instanceof HTMLElement)) return;

  const mainLink = item.querySelector(':scope > .menu-drawer__menu-item--mainlist');
  const childList = item.querySelector(':scope > .menu-drawer__menu--childlist');
  if (!(mainLink instanceof HTMLElement) || !(childList instanceof HTMLElement)) return;

  item.classList.add('menu-drawer__list-item--mobile-drilldown');
  mainLink.setAttribute('aria-haspopup', 'true');
  if (!mainLink.hasAttribute('aria-expanded')) mainLink.setAttribute('aria-expanded', 'false');

  if (childList.querySelector(':scope > .menu-drawer__mobile-submenu-header')) return;

  const title = mainLink.textContent?.trim() || '';

  const header = document.createElement('div');
  header.className = 'menu-drawer__nav-buttons menu-drawer__mobile-submenu-header';

  const backButton = document.createElement('button');
  backButton.type = 'button';
  backButton.className = 'button menu-drawer__back-button menu-drawer__mobile-back-button focus-inset';
  backButton.setAttribute('aria-label', title ? `Back to ${title}` : 'Back');

  const backIcon = document.createElement('span');
  backIcon.className = 'menu-drawer__mobile-back-icon';
  backIcon.setAttribute('aria-hidden', 'true');
  backIcon.textContent = '‹';

  const backText = document.createElement('span');
  backText.className = 'menu-drawer__menu-item-text wrap-text';
  backText.textContent = title;

  backButton.append(backIcon, backText);

  const closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.className = 'button button-unstyled close-button menu-drawer__close-button menu-drawer__mobile-close-button focus-inset';
  closeButton.setAttribute('aria-label', 'Close');

  const closeIcon = document.createElement('span');
  closeIcon.className = 'menu-drawer__mobile-close-icon';
  closeIcon.setAttribute('aria-hidden', 'true');
  closeIcon.textContent = '×';

  closeButton.append(closeIcon);
  header.append(backButton, closeButton);
  childList.prepend(header);
}

function closeMobileHeaderSubmenu(item, restoreFocus = true) {
  if (!(item instanceof HTMLElement)) return;

  item.removeAttribute('open-mobile-submenu');
  const mainLink = item.querySelector(':scope > .menu-drawer__menu-item--mainlist');
  if (mainLink instanceof HTMLElement) {
    mainLink.setAttribute('aria-expanded', 'false');
    if (restoreFocus && mobileDrilldownMedia.matches) mainLink.focus({ preventScroll: true });
  }
}

function resetMobileHeaderDrilldown(drawer) {
  if (!(drawer instanceof Element)) return;

  drawer.querySelectorAll('.menu-drawer__list-item--mobile-drilldown[open-mobile-submenu], [open-mobile-submenu]').forEach((item) => {
    closeMobileHeaderSubmenu(item, false);
  });
  getDrawerPanel(drawer)?.classList.remove('menu-drawer--has-submenu-opened');
}

function openMobileHeaderSubmenu(drawer, item, mainLink) {
  prepareMobileHeaderDrilldownItem(item);

  drawer.querySelectorAll('.menu-drawer__list-item--mobile-drilldown[open-mobile-submenu], [open-mobile-submenu]').forEach((openItem) => {
    if (openItem !== item) closeMobileHeaderSubmenu(openItem, false);
  });

  item.setAttribute('open-mobile-submenu', '');
  mainLink.setAttribute('aria-expanded', 'true');
  getDrawerPanel(drawer)?.classList.add('menu-drawer--has-submenu-opened');

  const backButton = item.querySelector('.menu-drawer__mobile-back-button');
  if (backButton instanceof HTMLElement) {
    window.requestAnimationFrame(() => backButton.focus({ preventScroll: true }));
  }
}

function handleMobileHeaderDrilldownClick(event) {
  if (!mobileDrilldownMedia.matches || !(event.target instanceof Element)) return;

  const drawer = event.target.closest('header-drawer');
  if (!(drawer instanceof HTMLElement)) return;

  const backButton = event.target.closest('.menu-drawer__mobile-back-button');
  if (backButton && drawer.contains(backButton)) {
    event.preventDefault();
    const item = backButton.closest('.menu-drawer__list-item--mobile-drilldown, [open-mobile-submenu]');
    closeMobileHeaderSubmenu(item);
    if (!drawer.querySelector('[open-mobile-submenu]')) {
      getDrawerPanel(drawer)?.classList.remove('menu-drawer--has-submenu-opened');
    }
    return;
  }

  const closeButton = event.target.closest('.menu-drawer__mobile-close-button');
  if (closeButton && drawer.contains(closeButton)) {
    event.preventDefault();
    resetMobileHeaderDrilldown(drawer);
    if (typeof drawer.close === 'function') drawer.close();
    return;
  }

  const mainLink = event.target.closest('.menu-drawer__menu-item--mainlist');
  const item = mainLink?.closest(TOP_LEVEL_FLAT_ITEM_SELECTOR);
  if (!(mainLink instanceof HTMLElement) || !(item instanceof HTMLElement) || mainLink.parentElement !== item) return;

  event.preventDefault();
  openMobileHeaderSubmenu(drawer, item, mainLink);
}

function setupMobileHeaderDrilldown(scope = document) {
  installMobileHeaderDrilldownStyles();

  if (!mobileDrilldownMedia.matches) return;

  const drawers = scope instanceof Element && scope.matches('header-drawer')
    ? [scope]
    : Array.from(scope.querySelectorAll?.('header-drawer') ?? []);

  drawers.forEach((drawer) => {
    if (!(drawer instanceof HTMLElement)) return;
    drawer.querySelectorAll(TOP_LEVEL_FLAT_ITEM_SELECTOR).forEach(prepareMobileHeaderDrilldownItem);
  });
}

function scheduleMobileHeaderDrilldownSetup(scope = document) {
  if (!mobileDrilldownMedia.matches) return;
  if (setupQueued) return;

  setupQueued = true;
  window.requestAnimationFrame(() => {
    setupQueued = false;
    setupMobileHeaderDrilldown(scope);
  });
}

function observeHeaderHydration() {
  if (bodyObserver || !document.body) return;

  bodyObserver = new MutationObserver((mutations) => {
    if (!mobileDrilldownMedia.matches) return;

    for (const mutation of mutations) {
      if (mutation.type !== 'childList') continue;
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('header-drawer, #header-component') || node.querySelector('header-drawer, #header-component')) {
          scheduleMobileHeaderDrilldownSetup(document);
          return;
        }
      }
    }
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });
}

function onReady() {
  installMobileHeaderDrilldownStyles();
  setupMobileHeaderDrilldown();
  observeHeaderHydration();

  window.setTimeout(() => setupMobileHeaderDrilldown(), 250);
  window.setTimeout(() => setupMobileHeaderDrilldown(), 1000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', onReady, { once: true });
} else {
  onReady();
}

document.addEventListener('click', handleMobileHeaderDrilldownClick, true);

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) setupMobileHeaderDrilldown(event.target);
});

mobileDrilldownMedia.addEventListener('change', (event) => {
  if (event.matches) {
    setupMobileHeaderDrilldown();
  } else {
    document.querySelectorAll('header-drawer').forEach(resetMobileHeaderDrilldown);
  }
});
